import { useMemo } from 'react';
import { ROLES, Role } from '../types/auth';
import { useProfileStore } from '../stores/profileStore';

export function useProfileRole() {
  const { profile } = useProfileStore();

  const role = profile?.role as Role | undefined;

  const isAdmin = role === ROLES.ADMIN;
  const isRecruiter = role === ROLES.RECRUITER;
  const isFreelancer = role === ROLES.FREELANCER;

  return useMemo(
    () => ({
      profile,
      role,
      isAdmin,
      isRecruiter,
      isFreelancer,
    }),
    [profile, role, isAdmin, isFreelancer, isRecruiter]
  );
}
